import React, { useState } from 'react';
import { TextField } from '@fluentui/react';

const MicDosageNumber = (props) => {
    const [fieldValue, setFieldValue] = useState(
        props.config.value !== undefined ? props.config.value : ''
    );
    const [lastConfiguredState, setLastConfiguredState] = useState(
        props.config.value
    );

    if (lastConfiguredState !== props.config.value) {
        setLastConfiguredState(props.config.value);
        setFieldValue(props.config.value);
    }

    const valueChangeHandler = (event, value) => {
        let finalValue = '';
        let finalNumber = '';
        let finalDecimal = '';
        let decimalAdded = false;
        let characterNumber = 1;
        for (const str of value) {
            let canUse = false;

            if (!decimalAdded) {
                canUse = str >= '0' && str <= '9' && finalNumber.length < 4;
                if (canUse) {
                    finalNumber += str;
                }
                canUse =
                    canUse ||
                    ((str === '<' || str === '>') && characterNumber === 1);
                canUse =
                    canUse ||
                    (characterNumber === 2 && finalValue + str === '<=');
                if (str === '.' && !decimalAdded) {
                    canUse = true;
                    decimalAdded = true;
                }
            } else {
                canUse = str >= '0' && str <= '9' && finalDecimal.length < 11;
                if (canUse) {
                    finalDecimal += str;
                }
            }

            if (canUse) {
                finalValue += str;
            }
            characterNumber++;
        }

        setFieldValue(finalValue);
    };

    const focusOutEventHandler = () => {
        props.changeHandler(props.config.Id, fieldValue);
        setFieldValue(lastConfiguredState);
    };

    return (
        <TextField
            id={props.config.Id}
            autoComplete="off"
            onChange={valueChangeHandler}
            value={fieldValue}
            validateOnFocusOut={true}
            onNotifyValidationResult={focusOutEventHandler}
            tabIndex={
                props.config.TabIndex !== undefined ? props.config.TabIndex : 0
            }
        />
    );
};

export default MicDosageNumber;
